"use strict";const RNRenderer={};export{RNRenderer};